import { PATH_DOCUMENTATION } from 'constants/uTagConstants/paths';
import { recordEvent, recordEventCustomOnly, RELIABLE, PAGE_PRODUCT } from 'utilities/uTagging';
import DOCUMENTATION_PRODUCT_NAME from 'utilities/uTagging';
import { documentTypeToTaggingNames } from '../newAccountSteps/profileSteps/ProfileStep5/tagging';

export const doTagOnRemoveFile = ({ userProfile, docNumberEncrypted, title }) =>
    recordEvent(
        PATH_DOCUMENTATION,
        PAGE_PRODUCT,
        'eliminar documento',
        `eliminar documento ${title} correcto`,
        userProfile.recordId,
        userProfile.userId,
        RELIABLE[userProfile.identityMethod],
        userProfile.investmentType,
        docNumberEncrypted,
        {
            nombreProducto: DOCUMENTATION_PRODUCT_NAME,
        }
    );

export const doTagOnClickUploadBox = docId =>
    recordEventCustomOnly({
        categoriaEvento: 'eventos onboarding',
        accionEvento: 'clickLink',
        etiquetaEvento: `foto ${documentTypeToTaggingNames([docId])}`,
    });
